var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37516 9.20829H10.6252M6.37516 12.0416H8.50016M2.8335 2.83329V14.1666C2.8335 14.5423 2.98275 14.9027 3.24843 15.1684C3.5141 15.434 3.87444 15.5833 4.25016 15.5833H12.7502C13.1259 15.5833 13.4862 15.434 13.7519 15.1684C14.0176 14.9027 14.1668 14.5423 14.1668 14.1666V5.90888C14.1668 5.72015 14.1291 5.53333 14.0558 5.35938C13.9826 5.18544 13.8754 5.02788 13.7404 4.89596L10.5954 1.82038C10.3308 1.56159 9.97532 1.41667 9.60516 1.41663H4.25016C3.87444 1.41663 3.5141 1.56588 3.24843 1.83156C2.98275 2.09723 2.8335 2.45757 2.8335 2.83329Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 1.41663V4.24996C9.91699 4.62568 10.0662 4.98602 10.3319 5.25169C10.5976 5.51737 10.9579 5.66663 11.3337 5.66663H14.167",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/file icon.82ca5f68c4a67e31316022049c218ef4.svg";
export { ForwardRef as ReactComponent };